import { Controller } from "@hotwired/stimulus"
import { updateUrlParams } from "../utilities/url_params"

// TODO: move to forms catalog
// Connects to data-controller="id-picker"
export default class extends Controller {
  connect () {
  }

  // append form data to `return_to` url params
  updateReturnToParam (e) {
    const link = e.currentTarget
    const url = new URL(link.href)
    const returnTo = url.searchParams.get("return_to")
    if (!returnTo) return
    const returnToUrl = new URL(returnTo, url.origin)

    const form = link.closest("form")
    const formData = new FormData(form)

    updateUrlParams(returnToUrl, formData.entries())

    url.searchParams.set("return_to", returnToUrl.href)
    link.href = url
  }
}
